module.exports = __webpack_public_path__ + "static/media/rwa.581157c6.svg";